import script from "./request-excuses.vue?vue&type=script&setup=true&lang=js"
export * from "./request-excuses.vue?vue&type=script&setup=true&lang=js"

import "./request-excuses.vue?vue&type=style&index=0&id=52fd686d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52fd686d"]])

export default __exports__